/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DocumentsInputs */

const cs_enum_documents = /** @type {(inputs: Enum_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenty`)
};

const en_enum_documents = /** @type {(inputs: Enum_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Enum_DocumentsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_documents = /** @type {((inputs?: Enum_DocumentsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DocumentsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_documents(inputs)
	return cs_enum_documents(inputs)
});